(() => {
  if (window.__shoevCollectionRuntime) return;
  window.__shoevCollectionRuntime = true;

  let controlIndex = 0;
  let bootQueued = false;

  const closeSort = (control, returnFocus = false) => {
    if (!control) return;
    const trigger = control.querySelector('[data-shoev-sort-trigger]');
    const menu = control.querySelector('[data-shoev-sort-menu]');
    if (!trigger || !menu) return;
    trigger.setAttribute('aria-expanded', 'false');
    control.classList.remove('is-open');
    menu.hidden = true;
    if (returnFocus) trigger.focus();
  };

  const closeAllSorts = (except) => {
    document.querySelectorAll('[data-shoev-sort-control].is-open').forEach((control) => {
      if (control !== except) closeSort(control);
    });
  };

  const enhanceSort = (select) => {
    if (select.dataset.shoevSortReady === 'true') return;
    const selectShell = select.closest('.select');
    const field = select.closest('.facet-filters__field');
    if (!selectShell || !field) return;

    const label = field.querySelector('label[for]');
    const labelText = label?.textContent.trim() || '';
    if (labelText) select.setAttribute('aria-label', labelText);

    const control = document.createElement('div');
    const trigger = document.createElement('button');
    const triggerLabel = document.createElement('span');
    const menu = document.createElement('div');
    const controlId = `ShoevSort-${++controlIndex}`;

    control.className = 'shoev-sort';
    control.dataset.shoevSortControl = '';
    trigger.type = 'button';
    trigger.id = `${controlId}-trigger`;
    trigger.className = 'shoev-sort__trigger';
    trigger.dataset.shoevSortTrigger = '';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', `${controlId}-menu`);
    triggerLabel.className = 'shoev-sort__value';
    triggerLabel.dataset.shoevSortValue = '';
    trigger.append(triggerLabel);

    const nativeChevron = selectShell.querySelector(':scope > .svg-wrapper');
    if (nativeChevron) {
      const chevron = nativeChevron.cloneNode(true);
      chevron.classList.add('shoev-sort__chevron');
      chevron.setAttribute('aria-hidden', 'true');
      trigger.append(chevron);
    }

    menu.id = `${controlId}-menu`;
    menu.className = 'shoev-sort__menu';
    menu.dataset.shoevSortMenu = '';
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-labelledby', trigger.id);
    menu.hidden = true;

    [...select.options].forEach((option) => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'shoev-sort__option';
      item.dataset.value = option.value;
      item.textContent = option.textContent.trim();
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', String(option.selected));
      menu.append(item);
    });

    const sync = () => {
      const selected = select.selectedOptions[0];
      triggerLabel.textContent = selected?.textContent.trim() || '';
      trigger.setAttribute('aria-label', [labelText, triggerLabel.textContent].filter(Boolean).join(': '));
      menu.querySelectorAll('[role="option"]').forEach((item) => {
        item.setAttribute('aria-selected', String(item.dataset.value === select.value));
      });
    };

    const open = (focusOption = true) => {
      closeAllSorts(control);
      menu.hidden = false;
      control.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      if (focusOption) {
        (menu.querySelector('[aria-selected="true"]') || menu.querySelector('[role="option"]'))?.focus();
      }
    };

    trigger.addEventListener('click', () => {
      if (control.classList.contains('is-open')) closeSort(control);
      else open();
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      open();
    });

    menu.addEventListener('click', (event) => {
      const option = event.target.closest('[role="option"]');
      if (!option) return;
      select.value = option.dataset.value;
      sync();
      closeSort(control, true);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    menu.addEventListener('keydown', (event) => {
      const options = [...menu.querySelectorAll('[role="option"]')];
      const currentIndex = options.indexOf(document.activeElement);
      let nextIndex;
      if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % options.length;
      if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + options.length) % options.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = options.length - 1;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSort(control, true);
        return;
      }
      if (nextIndex === undefined) return;
      event.preventDefault();
      options[nextIndex]?.focus();
    });

    select.addEventListener('change', (event) => {
      sync();
      const facets = select.closest('facet-filters-form');
      if (typeof facets?.onSubmitHandler === 'function') {
        facets.onSubmitHandler(event);
      } else {
        select.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    control.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!control.contains(document.activeElement)) closeSort(control);
      });
    });

    control.append(trigger, menu);
    selectShell.append(control);
    select.dataset.shoevSortReady = 'true';
    select.tabIndex = -1;
    select.classList.add('shoev-sort__native', 'visually-hidden');
    selectShell.classList.add('shoev-sort--enhanced');
    if (label) label.htmlFor = trigger.id;
    sync();
  };

  const boot = (scope = document) => {
    const selector = '.shoev-collection facet-filters-form.small-hide select.facet-filters__sort';
    if (scope.matches?.(selector)) enhanceSort(scope);
    scope.querySelectorAll?.(selector).forEach(enhanceSort);
  };

  document.addEventListener('click', (event) => {
    const activeControl = event.target.closest('[data-shoev-sort-control]');
    closeAllSorts(activeControl);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openControl = document.querySelector('[data-shoev-sort-control].is-open');
    if (openControl) closeSort(openControl, true);
  });

  const observer = new MutationObserver((mutations) => {
    if (bootQueued || !mutations.some((mutation) => mutation.addedNodes.length)) return;
    bootQueued = true;
    queueMicrotask(() => {
      bootQueued = false;
      boot();
    });
  });

  boot();
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
